export default "__VITE_ASSET__4ee82471__"